import React from "react";
import PropTypes from "prop-types";

import Module from "../../../../components/Module";
import Loading from "../../../../components/Loading";
import Table from "../../../../components/Table";
import ShowHideArea from "../../../../components/ShowHideArea";
import { displayErrorMessage } from "../../../../utils";
import {withTranslation} from "react-i18next";

// The list of columns and their properties
export const columns = () => [
  {
    Header: "column.name",
    accessor: "person.full_name",
  },
  {
    Header: "column.position",
    accessor: "position",
  },
];

// The list of a administrators of aggregator
export const Administrators = (
  {
    isFetchingAggregator,
    errorMessageAggregator,
    administrators,
    isVisible,
    onPageChangeAdministrators,
    administratorsPage,
    t,
  },
) => {

  return (
    <ShowHideArea isVisible={isVisible}>
      {isFetchingAggregator && <Loading isVisible />}
      {displayErrorMessage(errorMessageAggregator)}
      <Module
        title={t("aggregatorView.administrators.title")}
        table={
          <Table
            loading={false}
            columns={columns()}
            data={administrators || []}
            onPageChange={onPageChangeAdministrators}
            page={administratorsPage}
          />
        }
      />
    </ShowHideArea>
  );
};

// propTypes for the Administrators component
Administrators.propTypes = {
  isFetchingAggregator: PropTypes.bool.isRequired,
  errorMessageAggregator: PropTypes.string.isRequired,
  administrators: PropTypes.array.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onPageChangeAdministrators: PropTypes.func.isRequired,
  administratorsPage: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};

// defaultProps for the Administrators component
Administrators.defaultProps = {
  errorMessageAggregator: "",
};

export default withTranslation()(Administrators);
